import React, { useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Button, Col, Container, Row } from "react-bootstrap";
import AnimatedSprite from "../../components/shared/AnimatedSprite";
import DashCard from "../../components/shared/DashCard";
import { FaBell } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { BsFillDeviceSsdFill } from "react-icons/bs";
import { useQuery } from "react-query";
import SplashPage from "../SplashPage";
import NotificationModal from "../../components/shared/notification/NotificationModal";

const PrivateDashboardPage = () => {

    // initial variables
    const API = new PrivateApi(); 
    const [animation, setAnimation] = useState(false);

    // fetch data
    const {data, error, isLoading} = useQuery('clientDashboard', API.client_dashboard, {staleTime: Infinity});

    // if loading or error
    if (isLoading) return <SplashPage />;
    if (error) return <SplashPage />;

    // random animation popup
    if (Math.random() < 0.08) {
        setAnimation(true);
    }

    // gui
    return (
        <Container className="text-start">
            <Row className="align-items-center">
                <Col xs="6">
                    <h1>Dashboard</h1>
                    <p className="text-secondary">Schnellzugriff auf die wichtigsten Funktionen</p>
                </Col>
                <Col xs="6" className="text-end">
                    <p className="text-muted">{new Date().toLocaleDateString('DE-de')}</p>
                </Col>
            </Row>

            {animation === true?
                <AnimatedSprite show={animation} setShow={setAnimation} />
                :null
            }

            <Row className="mt-5 justify-content-center">
                <Col xs="12" md="4" xl="4">
                    <DashCard
                        schema="warning"
                        path="/dashboard/news/"
                        icon={<FaBell size={80} className="text-warning" />}
                        counter={data.data.notifications.length === 0? "0": data.data.notifications.length}
                        text="News" 
                    />
                </Col>
                <Col xs="12" md="4" xl="4">
                    <DashCard
                        schema="cyan"
                        path="/dashboard/support/"
                        icon={<BiSupport size={80} className="text-cyan"/>}
                        counter={data.data.ticket_count === 0? "0": data.data.ticket_count}
                        text="Offene Tickets" 
                    />
                </Col>
                <Col xs="12" md="4" xl="4">
                    <DashCard 
                        schema="violet"
                        path="/dashboard/neuedokumente/"
                        icon={<AiOutlineCloudDownload size={80} className="text-violet"/>}
                        badge={data.data.download_count > 0? `Neue`: undefined}
                        text="Neue Dokumente" 
                    />
                </Col>
            </Row>
            <Row className="mt-5 mb-5">
                <Col xs="12" md="4" xl="4" hidden={data.data.anlagen_count === 0}>
                    <DashCard
                        schema="energo"
                        path="/dashboard/anlagen/"
                        icon={<BsFillDeviceSsdFill size={80} className="text-energo" />}
                        counter={data.data.anlagen_count === 0? "0": data.data.anlagen_count}
                        text="Meine Anlagen"
                    />
                </Col>
                <Col xs="12" md="4" xl="4" hidden={data.data.anlagen_count > 0}>
                    <DashCard
                        schema="energo"
                        path="/dashboard/anlagen/anmelden/"
                        icon={<BsFillDeviceSsdFill size={80} className="text-energo"/>}
                        pulse
                        text="Neue Anlage hinzufügen"
                        linkText="hinzufügen"
                    />
                </Col>
                <Col hidden={true}>
                    <Button onClick={() => setAnimation(true)}>Monkey</Button>
                </Col>
            </Row>

            {data.data.notifications && data.data.notifications.length > 0 ?
                <NotificationModal notifications={data.data.notifications} />
            : null}
        </Container>
    )
}

export default PrivateDashboardPage;